import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './store';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import AuthPage from './Components/Pages/Auth';
import Home from './Components/Pages/Home';
import Form from './Components/Pages/Form';
import List from './Components/Pages/List';
import Settings from './Components/Pages/Settings';

const root = ReactDOM.createRoot(document.getElementById('root'));
export const iframeSrc = process.env.REACT_APP_IFRAME_URL;
const userAgent = process.env.REACT_APP_USER_AGENT;

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: "auth",
        element: <AuthPage />
      },
      {
        path: "form/:key?",
        element: <Form />
      },
      {
        path: "list/:type",
        element: <List />
      },
      {
        path: "settings",
        element: <Settings />
      }
    ]
  },
], {
  basename: "/atlas-dfrs"
});

root.render(
<React.StrictMode>
  <StoreProvider iframeSrc={iframeSrc} userAgent={userAgent}>
    {/* <App /> */}
    <RouterProvider router={router} />
  </StoreProvider>
</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
